<template>
    
    <div ref="target" style="position: relative;">
        <div @click="show = !show; scrolls(); $emit('open', true)"><slot name="title"></slot></div> 
        <Transition>
        <div class="container fixed center" :style="{marginTop: top}"  :class="{'needscroll': scroll}"  v-if="show"><slot></slot></div>        
        </Transition>
    </div>

</template>

<!-- 
    <FixedMenu scroll>
        <template #title>Click</template>
        ...
    </FixedMenu> 
-->
<script>


export default {
    data: function () {return {
        show: false,
    }},
    
    mounted() {
        document.addEventListener('click', this.handleClick);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClick);
    },
    methods: {
        handleClick(event) {      
            if (!this.$refs.target.contains(event.target)) this.show = false                
        },
        scrolls(){            
            if (!this.$refs) return
            if (!this.$refs.target) return
            this.$refs.target.scrollTop = 0            
        }
    },

    props:{        
        scroll: Boolean,        
    },    
   
}
</script>
<style scoped>
    .container{
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
        left: 50%;
        top: 50%;
        background-color: var(--popupBack);
        box-shadow: var(--popupShadow);
        position: fixed;            
        transform: translate(-50%,-50%);        
    }
    
    .needscroll{
        overflow-y: scroll;
    }

.v-enter-active,
.v-leave-active {
  /* transition: opacity 0.5s ease; */
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>